import React, { useEffect, useState } from "react";
import { Table } from "antd";
import Breadcrumbs from "../../../components/Breadcrumbs";
import api from "../../../api/axios";
import { companyID, employeeDetails } from "../../../auth";
import RefereeDetailsModal from "../../../components/modelpopup/RefereeDetailsModal";
import Swal from "sweetalert2";

const Referrals = () => {
  const [referralsData, setReferralsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const company_id = companyID();
  const details = employeeDetails();

  const fetchReferrals = async () => {
    setLoading(true);
    try {
      const response = await api.get(`referrals/get-referees/${company_id}`);
      setReferralsData(response.data?.reverse());
    } catch (error) {
      console.error("Error fetching referrals:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveReferee = async (formData) => {
    const payload = {
      referrer: company_id,
      referee_name: formData.name,
      referee_email: formData.email,
      referee_phone: formData.phone,
      employee_id: details?.id,
      company_name: details?.company?.name,
    };
    try {
      const res = await api.post("/referrals/create", payload);
      Swal.fire({
        icon: "success",
        title: "Referral",
        text: "Referred successfully.",
        timer: 2000,
        showConfirmButton: true,
      });
      setShowModal(false);
    } catch (err) {
      let icon = "error";
      let title = "Error";
      let text = "Something went wrong. Please try again.";
      if (err.response.data.error.code === "EMAIL_SEND_FAILED") {
        icon = "success";
        title = "Referral";
        text = "Referred successfully.";
      }
      Swal.fire({
        icon: icon,
        title: title,
        text: text,
      });
    } finally {
      await fetchReferrals();
    }
  };

  const columns = [
    {
      title: "Referee Name",
      dataIndex: "referee_name",
      key: "referee_name",
    },
    {
      title: "Referee Email",
      dataIndex: "referee_email",
      key: "referee_email",
    },
    {
      title: "Referee Phone",
      dataIndex: "referee_phone",
      key: "referee_phone",
    },
    {
      title: "Referral Code",
      dataIndex: "referral_code",
      key: "referral_code",
    },
    {
      title: "Referral",
      dataIndex: "referral_used",
      key: "referral_used",
      render: (text, record) => (
        <span className={`badge bg-${text === 1 ? "info" : "success"}`}>
          {text === 1 ? "Redeemed" : "Active"}
        </span>
      ),
    },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchReferrals();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs
          maintitle="Referrals"
          title="Dashboard"
          subtitle="Referral"
          name="Refer"
          openModal={() => setShowModal(true)}
          page="referral"
          action="create"
        />

        <div className="table-responsive">
          <Table
            className="table-striped"
            columns={columns}
            dataSource={referralsData}
            rowKey={(record) => record.id}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: ["5", "10", "20", "50"],
              defaultPageSize: 10,
            }}
            // pagination={{ pageSize: 5 }}
            scroll={{ x: true }}
            tableLayout="auto"
            loading={loading}
          />
        </div>
        <RefereeDetailsModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleSave={handleSaveReferee}
          companyName={details}
          employee_id={details}
          referrer={company_id}
        />
      </div>
    </div>
  );
};

export default Referrals;
